import { Component } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  StorageKey,
  StorageService,
} from '../../services/common/storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../services/common/common.service';
import { ApiService } from '../../services/api.service';
import { ApiUrlHelper } from '../../services/api-url-helper/api-url-helper';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { delay, firstValueFrom, map, Observable, of } from 'rxjs';
import { CMSContentComponent } from '../cms-content/cms-content.component';
import { ReferralConsentDialogComponent } from '../referral-consent-dialog/referral-consent-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/languageService/language-service.service';

@Component({
  selector: 'app-signup-question',
  templateUrl: './signup-question.component.html',
  styleUrl: './signup-question.component.scss',
})
export class SignupQuestionComponent {
  signUpQuestion: FormGroup;
  selectedValue: string = '';
  isChecked: boolean = false;
  showError: boolean = false;
  passwordinputType = 'password';
  confirmPasswordinputTypes = 'password';
  email: string = '';
  userType: any = '';
  expiryDate: any = '';
  canShowPage: boolean = true;
  linkExpired: boolean = false;
  isRegistered: boolean = false;
  decryptUserTypeId: number = 0;
  partnerReferenceId: string | null = null;
  // Feature 210: true when the customer arrived from a referral signup link (?ref=),
  // which requires an explicit consent confirmation before registering.
  isReferralSignup: boolean = false;
  private consentAsked: boolean = false;
  hearedAboutUs = [{ value: '', viewValue: 'Select Option' }];
  constructor(
    private storageService: StorageService,
    private formBuilder: FormBuilder,
    public router: Router,
    private commonService: CommonService,
    private apiService: ApiService,
    private apiUrl: ApiUrlHelper,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private translate: TranslateService,
    private languageService: LanguageService
  ) {
    this.signUpQuestion = this.formBuilder.group(
      {
        firstQuestion: [
          '',
          [
            Validators.required,
            Validators.minLength(10),
            Validators.maxLength(50),
            this.noWhitespaceValidator,
          ],
        ],
        firstQuestionAnswer: [
          '',
          [Validators.required, Validators.maxLength(50)],
        ],
        secondQuestion: [
          '',
          [
            Validators.required,
            Validators.minLength(10),
            Validators.maxLength(50),
          ],
        ],
        secondQuestionAnswer: [
          '',
          [Validators.required, Validators.maxLength(50)],
        ],
        thirdQuestion: [
          '',
          [
            Validators.required,
            Validators.minLength(10),
            Validators.maxLength(50),
          ],
        ],
        thirdQuestionAnswer: [
          '',
          [Validators.required, Validators.maxLength(50)],
        ],
        password: [
          '',
          [
            Validators.required,
            Validators.pattern(this.commonService.passwordRegex),
          ],
        ],
        confirmPassword: [
          '',
          [
            Validators.required,
            // Validators.pattern(this.commonService.passwordRegex),
          ],
        ],
        referralCode: ['', []],
        heardAboutUS: ['', [Validators.required]],
      },
      {
        validators: this.MustMatch,
      }
    );
  }
  // ngOnInit(): void {
  //   this.route.queryParams.subscribe(params => {
  //     this.email = params['email'] || '';
  //     this.userType = params['usertype'] || '';
  //     if(this.email!='' && this.userType!='')
  //     {
  //       this.storageService.setValue('email',this.email);
  //       this.storageService.setValue('Type',this.userType);
  //     }
  //   });
  // }
  async ngOnInit(): Promise<void> {
    // Read PartnerReferenceId from sessionStorage before clearing localStorage
    try {
      this.partnerReferenceId = sessionStorage.getItem('PartnerReferenceId');
    } catch (e) {
      // sessionStorage unavailable (e.g. private browsing) — graceful degradation
      this.partnerReferenceId = null;
    }

    this.storageService.clearAll();

    history.pushState(null, '', location.href);
    window.addEventListener('popstate', () => {
      window.location.href = '/login'; // Forces reload and redirects
    });
    this.route.queryParams.subscribe(async (params) => {
      // Feature 210: from this page onward the journey is standard Senem RFP - no agency
      // white-label branding. The `ref` param is only used to detect that the customer
      // arrived from a referral signup link, which requires the consent gate below.
      this.isReferralSignup = !!params['ref'];
      // Social Media registration flow - OTP already verified, no expiry needed
      if (params['source'] === 'social-media' && params['email'] && params['firmId']) {
        this.email = params['email'];
        this.userType = 2; // Customer
        this.canShowPage = true;
        // Store firmId for social media lead completion
        try {
          sessionStorage.setItem('socialMediaFirmId', params['firmId']);
          sessionStorage.setItem('socialMediaSource', 'true');
        } catch (e) {}
        this.getListHearedAboutUs();
      } else if (
        params.hasOwnProperty('email') &&
        params.hasOwnProperty('usertype') &&
        params.hasOwnProperty('expiry')
      ) {
        this.email = decodeURIComponent(params['email'] || '');
        this.userType = decodeURIComponent(params['usertype'] || '');
        this.expiryDate = decodeURIComponent(params['expiry'] || '');
        if (!this.expiryDate) {
          this.linkExpired = true;
          return;
        }

        if (this.email && this.userType && this.expiryDate) {
          this.email = this.commonService.Decrypt(this.email);
          this.userType = parseInt(this.commonService.Decrypt(this.userType));
          this.expiryDate = this.commonService.Decrypt(this.expiryDate);
          const expiryDate = new Date(this.expiryDate);

          await this.CheckIsRegistered();
          const now = new Date();
          const expiryPlusOneHour = new Date(
            expiryDate.getTime() + 60 * 60 * 1000
          );
          if (now > expiryPlusOneHour) {
            this.linkExpired = true;
            // alert('This signup link has expired. Please request a new one.');
            this.canShowPage = false;
            // this.router.navigate(['/login']);
          } else if (this.isRegistered) {
            this.linkExpired = true;
            this.canShowPage = false;
            // alert('You are already registered. This signup link has expired.');
            // this.router.navigate(['/login']);
          } else {
            this.canShowPage = true;
            this.askReferralConsent();
            this.getListHearedAboutUs();
          }
        }
      } else {
        this.canShowPage = false;
      }
    });
  }

  /**
   * Feature 210: customers who arrive from a "Registration Signup Link" (sent after a firm
   * clicks "Move to Customer Referral") must explicitly consent to their information being
   * referred to Senem RFP before they can register.
   *
   * Yes -> continue with the normal signup-questions flow.
   * No  -> nothing is created; send them back to where they came from.
   */
  askReferralConsent() {
    if (!this.isReferralSignup || this.consentAsked) {
      return;
    }
    this.consentAsked = true;

    const dialogRef = this.dialog.open(ReferralConsentDialogComponent, {
      width: '520px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((consented: boolean) => {
      if (consented !== true) {
        // Declined: do not register anything, just leave the page.
        this.canShowPage = false;
        if (window.history.length > 1) {
          window.history.back();
        } else {
          this.router.navigate(['/login']);
        }
      }
    });
  }

  getListHearedAboutUs() {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.heardAboutUsMaster.getListForSignQuestion;
    this.apiService
      .doGet(apiUrl)
      .pipe()
      .subscribe({
        next: (response) => {
          this.spinner.hide();
          if (response && response.Success) {
            this.hearedAboutUs = [
              { value: '', viewValue: 'Select Option' },
              ...response.Data.map((item: any) => ({
                value: item.HeardId,
                viewValue: item.HeardAbout,
              })),
            ];
          } else {
            this.toaster.error(this.translate.instant(response.Message));
          }
        },
        error: (er) => {
          this.spinner.hide();
          this.toaster.error(er.Message);
        },
      });
  }
  onSignUp() {
    this.signUpQuestion.markAllAsTouched();
    Object.keys(this.signUpQuestion.controls).forEach((key) => {
      const control = this.signUpQuestion.get(key);
      if (control && typeof control.value === 'string') {
        control.setValue(control.value.trim(), { emitEvent: false });
      }
    });
    if (this.isChecked) {
      this.showError = false;
    } else {
      this.showError = true;
      return;
    }

    let passwordValid = this.signUpQuestion.controls['password'].value;
    let confirmPasswordValid =
      this.signUpQuestion.controls['confirmPassword'].value;
    // if (passwordValid !== confirmPasswordValid) {
    //   this.toaster.error(this.translate.instant('PASSWORD_MUST_MATCH_TOASTER'));
    //   return;
    // }
    if (this.signUpQuestion.valid) {
      const FormData = {
        firstQuestion:
          this.signUpQuestion.controls['firstQuestion'].value.trim(),
        firstQuestionAnswer:
          this.signUpQuestion.controls['firstQuestionAnswer'].value.trim(),
        secondQuestion:
          this.signUpQuestion.controls['secondQuestion'].value.trim(),
        secondQuestionAnswer:
          this.signUpQuestion.controls['secondQuestionAnswer'].value.trim(),
        thirdQuestion:
          this.signUpQuestion.controls['thirdQuestion'].value.trim(),
        thirdQuestionAnswer:
          this.signUpQuestion.controls['thirdQuestionAnswer'].value.trim(),
        password: this.signUpQuestion.controls['password'].value.trim(),
        confirmPassword:
          this.signUpQuestion.controls['confirmPassword'].value.trim(),
        referralCode:
          this.signUpQuestion.controls['referralCode'].value.trim() || null,
        heardAboutUS: this.signUpQuestion.controls['heardAboutUS'].value,
        email: this.email,
        userType: this.userType,
        partnerReferenceId: this.partnerReferenceId,
      };
      if (FormData.email == null && FormData.userType == null) {
        return;
      }

      // if (FormData.password != FormData.confirmPassword) {
      //   this.toaster.error("The password and Confirm password is not same.");
      //   return;
      // }

      this.spinner.show();
      const apiUrl = this.apiUrl.apiUrl.signUp.addSignUpQuestion;
      this.apiService
        .doPost(apiUrl, FormData)
        .pipe()
        .subscribe({
          next: (response) => {
            this.spinner.hide();
            if (response && response.Success) {
              this.toaster.success(this.translate.instant(response.Message));
              // Clear PartnerReferenceId from sessionStorage after successful signup
              try {
                sessionStorage.removeItem('PartnerReferenceId');
              } catch (e) {
                // sessionStorage unavailable — ignore
              }
              this.storageService.clearAll();
              if (response.Data.IsRegisterd) {
                this.router.navigate(['/login']);
              }
              else if (response.Data.IsRegisterd == false && response.Data.UserType == 2) {
                // Social Media flow: store token and go to /register directly
                const isSocialMedia = sessionStorage.getItem('socialMediaSource') === 'true';
                if (isSocialMedia && response.Data.Token) {
                  this.storageService.setValue(
                    StorageKey.authToken,
                    response.Data.Token
                  );
                  this.router.navigate(['/register']);
                } else {
                  this.router.navigate(['/login']);
                }
              }
              else if (
                response.Data.IsRegisterd == false &&
                response.Data.UserType == '2'
              ) {
                this.storageService.setValue(
                  StorageKey.authToken,
                  response.Data.Token
                );
                this.router.navigate(['/register']); //admin registration
              } else if (
                response.Data.IsRegisterd == false &&
                response.Data.UserType == '3'
              ) {
                this.storageService.setValue(
                  StorageKey.authToken,
                  response.Data.Token
                );
                this.storageService.setValue('email', FormData.email);
                this.router.navigate(['/firm-registration']); //vendor registration
              } else if (
                response.Data.IsRegisterd == false &&
                response.Data.UserType == '4'
              ) {
                this.storageService.setValue(
                  StorageKey.authToken,
                  response.Data.Token
                );
                this.router.navigate(['/agent-profile']); //registration Page redirect Agent
              } else if (
                response.Data.IsRegisterd == false &&
                response.Data.UserType == '5'
              ) {
                // Partner flow: redirect to login with userType param
                this.router.navigate(['/login'], { queryParams: { userType: '5' } });
              }
              this.saveLanguage();
            } else {
              this.toaster.error(this.translate.instant(response.Message));
            }
          },
          error: (er) => {
            this.spinner.hide();
            this.toaster.error(er.Message);
          },
        });
    }
  }
  onCheckboxChange(event: any) {
    if (event.checked) {
      this.showError = false;
      this.isChecked = true;
    } else {
      this.showError = true;
      this.isChecked = false;
    }
  }
  changeInputType(input_type: any, fieldName: any) {
    if (fieldName == 'password') {
      if (input_type == 'password') {
        this.passwordinputType = 'text';
      } else {
        this.passwordinputType = 'password';
      }
    } else if (fieldName == 'confirmPassword') {
      if (input_type == 'password') {
        this.confirmPasswordinputTypes = 'text';
      } else {
        this.confirmPasswordinputTypes = 'password';
      }
    }
  }
  noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
    return (control.value || '').trim().length === 0
      ? { required: true }
      : null;
  }
  onGoogle() { }

  openDialog(content?: any): void {
    const dialogRef = this.dialog.open(CMSContentComponent, {
      width: '500px',
      data: content ? { content: content } : null,
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
      }
    });
  }

  redirectToTermsAndConditionsPage() {
    const userType = encodeURIComponent(btoa(this.userType));
    const url = `/terms-and-conditions?usertype=${userType}`;
    window.open(url, '_blank');
  }
  async CheckIsRegistered(): Promise<boolean> {
    const formData = {
      Email: this.email,
    };
    const apiUrl = this.apiUrl.apiUrl.forgetPassword.getUserType;

    try {
      this.spinner.show();

      const response: any = await firstValueFrom(
        this.apiService.doPost(apiUrl, formData)
      );

      this.spinner.hide();
      if (response && response.Success) {
        if (response.Data.DefaultFirmId != null) {
          this.isRegistered = false;
          return false;
        }
        this.isRegistered = true;
        return true;
      } else {
        this.isRegistered = false;
        return false;
      }
    } catch (error: any) {
      this.spinner.hide();
      console.error(error);
      this.toaster.error(
        error.Message || this.translate.instant('AN_ERROR_OCCURED')
      );
      return false;
    }
  }

  saveLanguage() {
    const selectedLang = this.languageService.getLanguage();
    let apiUrl = this.apiUrl.apiUrl.account.savePreferLanguage;
    let email = this.storageService.getTokenData()?.Email;
    let objdata = {
      Email: email,
      PreferLanguage: selectedLang,
    };

    this.apiService.doPost(apiUrl, objdata).subscribe({
      next: (data) => {
        if (data && data.Success) {
          // this.toaster.success(this.translate.instant(data.Message));
        }
      },
      error: (err) => {
        this.toaster.error(err);
      },
    });
  }
  MustMatch: ValidatorFn = (formGroup: FormGroup): ValidationErrors | null => {
    const password = formGroup.get('password');
    const confirm = formGroup.get('confirmPassword');

    if (!password || !confirm) {
      return null;
    }

    if (confirm.errors && !confirm.errors['mustMatch']) {
      // Exit if another validator has found an error
      return null;
    }

    if (password.value !== confirm.value) {
      confirm.setErrors({ mustMatch: true });
    } else {
      confirm.setErrors(null);
    }

    return null;
  };
}
